export enum PurchaseOrderStatusEnum {
    open,
    closed,
    purchased
}